import store from '@/store';
import handleNavigation from '@/utils/navigationUtils';
import { APP_MARKET_FEATURE_FLAG } from '../constants/appMarketConstants';

const LEGACY_WIZARD_MODAL = 'AppMarketWizard';
const MARKET_GRID_SENTINEL = 'main';

const openAppMarket = ({ appCodeName: requestedCodeName = '' } = {}) => {
  const appCodeName = requestedCodeName === MARKET_GRID_SENTINEL ? '' : requestedCodeName;

  if (!store.getters['BusinessStore/hasFeature'](APP_MARKET_FEATURE_FLAG)) {
    const payload = appCodeName ? [{}, {}, appCodeName] : [{}, {}];
    return store.dispatch('ModalStore/openModal', { name: LEGACY_WIZARD_MODAL, payload });
  }

  return handleNavigation(appCodeName
    ? { name: 'appMarketAppInfo', params: { appCodeName } }
    : { name: 'appMarket' });
};

export default {
  openAppMarket,
};
